module.exports = __webpack_public_path__ + "static/media/img7.f15c966f.jpg";